import { render, staticRenderFns } from "./TablePatient.vue?vue&type=template&id=80298bdc"
import script from "./TablePatient.vue?vue&type=script&lang=js"
export * from "./TablePatient.vue?vue&type=script&lang=js"
import style0 from "./TablePatient.vue?vue&type=style&index=0&id=80298bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports